import { Routes } from '@angular/router';
import { CustomerGuard, CustomerLocationGuard } from '@next/core-lib/relationships';

import { ManualCropsComponent } from './components/manual-crops/manual-crops.component';
import { ListComponent } from './components/dashboard-widget/list.component';
import { ReportComponent } from './components/report/report.component';

export const advicesRoutes: Routes = [
  {
    path: '',
    component: ListComponent,
    canActivate: [CustomerGuard],
  },
  {
    path: 'crops',
    component: ManualCropsComponent,
    canActivate: [CustomerLocationGuard],
  },
  {
    path: 'report',
    component: ReportComponent,
    canActivate: [CustomerGuard],
  },
];
